import { render, staticRenderFns } from "./content.vue?vue&type=template&id=ec605d98&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"
import style0 from "./content.vue?vue&type=style&index=0&id=ec605d98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec605d98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec605d98')) {
      api.createRecord('ec605d98', component.options)
    } else {
      api.reload('ec605d98', component.options)
    }
    module.hot.accept("./content.vue?vue&type=template&id=ec605d98&scoped=true", function () {
      api.rerender('ec605d98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/releaseManage/infoFrom/content.vue"
export default component.exports